import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1129.4317,113 L1129.4317,1807.14754 L936.637705,1807.14754 L484.865027,1355.37487 L169.414754,1355.37487 C76.9447931,1355.37487 1.52195439,1280.87673 0.0227446084,1188.75695 L-4.54747351e-13,1185.96011 L-4.54747351e-13,734.187433 C-4.54747351e-13,641.717471 74.4981391,566.294633 166.617911,564.795423 L169.414754,564.772678 L484.865027,564.772678 L936.637705,113 L1129.4317,113 Z M1016.48853,225.94317 L983.396178,225.94317 L564.715848,644.623499 L564.715848,1275.52404 L983.396178,1694.20437 L1016.48853,1694.20437 L1016.48853,225.94317 Z M1840.15059,637.722353 L1920,717.571765 L1677.62824,959.943529 L1920,1202.42824 L1840.15059,1282.27765 L1597.66588,1039.90588 L1355.29412,1282.27765 L1275.44471,1202.42824 L1517.81647,959.943529 L1275.44471,717.571765 L1355.29412,637.722353 L1597.66588,880.094118 L1840.15059,637.722353 Z M451.772678,677.715848 L169.414754,677.715848 C138.665976,677.715848 113.451979,702.511662 112.950773,733.254045 L112.94317,734.187433 L112.94317,1185.96011 C112.94317,1216.8207 137.84968,1241.92512 168.484687,1242.42413 L169.414754,1242.4317 L451.772678,1242.4317 L451.772678,677.715848 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAudioOffLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAudioOffLine, _Component);

  var _super = _createSuper(IconAudioOffLine);

  function IconAudioOffLine() {
    _classCallCheck(this, IconAudioOffLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAudioOffLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAudioOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAudioOffLine.displayName = "IconAudioOffLine";
  return IconAudioOffLine;
}(Component);

IconAudioOffLine.glyphName = 'audio-off';
IconAudioOffLine.variant = 'Line';
IconAudioOffLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAudioOffLine;
export { IconAudioOffLine };